module.exports = __webpack_public_path__ + "img/school4.12a939bf.jpg";